// extracted by mini-css-extract-plugin
module.exports = {"image__wrapper":"Image_image__wrapper__LqCLB","image__image":"Image_image__image__JDA7z","image__animation":"Image_image__animation__Qmgo0"};